<template>
  <div id="category">
    <div class="container-fluid bg-cl-secondary" v-if="getCurrentCategory.parent_id === designerCategoryId">
      <div class="container py20">
        <div class="row">
          <div class="col-xs-12 col-md-6 col-lg-5 brand-header">
            <h1 class="cl-dark-blue weight-500 uppercase fs50">
              {{ getCurrentCategory.name }}
            </h1>
            <span class="cl-dark-blue fs-basic" :class="{ 'expanded' : expanded }" v-html="getCurrentCategory.description" />
            <p v-show="!expanded && getCurrentCategory.description" @click="expandDesc" class="h5 underline pointer visible-md">
              {{ $t('expand description') }}
            </p>
          </div>
          <div class="col-xs-12 col-md-6 col-lg-7 flex middle-xs">
            <img
              v-if="getCurrentCategory.image"
              :alt="getCurrentCategory.name"
              :src="thumbnail"
              height="auto"
              width="50%"
              class="brand-image"
              data-testid="brandImage"
            >
            <img
              v-if="getCurrentCategory.thumbnail_image"
              :alt="getCurrentCategory.name"
              :src="thumbnail1"
              height="auto"
              width="50%"
              class="brand-image"
              data-testid="brandImage"
            >
          </div>
        </div>
      </div>
    </div>
    <div class="container pb60">
      <div v-if="getCurrentCategory.id === designerCategoryId" class="row m0 pt15">
        <marki :name="getCurrentCategory.name" :categories="getCurrentCategory.children_data" />
        <div id="category-desc" class="col-sm-12 category-desc weight-400 cl-black lh25">
          <div v-html="getCurrentCategory.description" class="category-inner" :class="{ 'expanded' : expanded }" />
          <span class="show-more" @click="expandDesc" v-if="!expanded && getCurrentCategory.description">{{ $t('Expand') }}</span>
        </div>
      </div>
      <div v-else-if="getCurrentCategory.id === fashionSubscriptionCategoryId" class="row m0">
        <subscription-plans :thumbnail="getCurrentCategory.image" :name="getCurrentCategory.name" :products="getCategoryProducts" />
      </div>
      <div v-else class="bg-cl-white">
        <div class="row pb5 pt10 breadcrumbs-row">
          <div class="col-lg-2dot4 col-xs-12 flex middle-xs center-xs start-lg my10">
            <breadcrumbs />
          </div>
          <div class="col-xs-12 visible-md center-xs">
            <h3 class="category-title" v-show="getCurrentCategory.parent_id !== designerCategoryId">
              {{ getCurrentCategory.name }}
              <span class="h5">
                ({{ getCategoryProductsTotal }})
              </span>
            </h3>
          </div>
          <div class="col-xs-12 visible-md flex">
            <div class="col-xs-6">
              <span
                class="active-label pointer brdr-1 brdr-cl-secondary-gray py10 px15 h5 active-label cl-light-gray flex middle-xs center-xs uppercase"
                @click="toggleFilters"
              >
                {{ $t('Filters') }}
              </span>
            </div>
            <sort-by-mobile
              class="col-xs-6"
              @change="changeFilter"
              :value="getCurrentSearchQuery.sort"
            />
          </div>
          <div class="border-box col-md-9 col-lg-9dot6 flex between-xs middle-xs hidden-md">
            <div class="active-filters row mx0" v-show="hasActiveFilters || isQueryNotEmpty">
              <active-filters :filters="getCurrentFilters" @change="changeFilter" />
              <span
                class="h5 pointer bg-cl-white cl-light-gray mr10 mb5 underline uppercase flex middle-xs small-space"
                @click="resetAllFilters"
              >
                {{ $t('Clear filters') }}
              </span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-2dot4 start-xs category-filters" :class="{ 'active-filters': isMobileFitersOpen }">
            <div class="visible-md row mx0" v-show="isActiveFilters" :class="[{ 'full-width' : !isFiltersToogle}]">
              <active-filters :filters="getCurrentFilters" @change="changeFilter" />
              <span
                class="h5 pointer bg-cl-white cl-light-gray mr10 mb5 underline uppercase flex middle-xs small-space"
                @click="resetAllFilters"
              >
                {{ $t('Clear filters') }}
              </span>
            </div>
            <sidebar :filters="getAvailableFilters" @changeFilter="changeFilter" @toogleUpdate="onFiltersChange" />
          </div>
          <div class="col-md-12 col-lg-9dot6 border-box products-list">
            <div class="flex end-xs middle-xs hidden-md">
              <p class="m0 productTotal-text pr10">
                {{ start() + 1 }}
                -
                {{ end() }}
                {{ $t('from') }}
                <span class="uppercase">{{ getCategoryProductsTotal }}</span>
                {{ $t('products') }}
              </p>
              <sort-by
                @change="changeFilter"
                :value="getCurrentSearchQuery.sort"
              />
              <ListingPagination
                v-if="totalPages > 1"
                class="product-list__pagination"
                :current="currentPage"
                :total="totalPages"
                :visible="3"
                :variant="2"
              />
            </div>
            <div v-if="isCategoryEmpty" class="hidden-xs">
              <h4 data-testid="noProductsInfo">
                {{ $t('No products found!') }}
              </h4>
              <p>{{ $t('Please change Your search criteria and try again. If still not finding anything relevant, please visit the Home page and try out some of our bestsellers!') }}</p>
            </div>
            <lazy-hydrate :trigger-hydration="!loading" v-if="isLazyHydrateEnabled">
              <product-listing :current-category-name="isQueryFilterActive ? 'Search page' : getCurrentCategory.name" :columns="defaultColumn" :products="products" />
            </lazy-hydrate>
            <product-listing v-else :current-category-name="isQueryFilterActive ? 'Search page' : getCurrentCategory.name" :columns="defaultColumn" :products="products" />
            <div class="flex middle-xs between-sm center-xs px8">
              <p class="m0 productTotal-text pr10 hidden-xs">
                {{ start() + 1 }}
                -
                {{ end() }}
                {{ $t('from') }}
                <span class="uppercase">{{ getCategoryProductsTotal }}</span>
                {{ $t('products') }}
              </p>
              <ListingPagination
                v-if="totalPages > 1"
                class="product-list__pagination"
                :current="currentPage"
                :total="totalPages"
                :visible="3"
              />
            </div>
          </div>
          <div id="category-desc" class="col-sm-12 category-desc weight-400 cl-black lh25" v-if="getCurrentCategory.parent_id !== designerCategoryId && showCategoryDescribe">
            <div v-html="getCurrentCategory.description" class="category-inner" :class="{ 'expanded' : expanded }" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration'
import Sidebar from '../components/core/blocks/Category/Sidebar.vue'
import ProductListing from '../components/core/ProductListing.vue'
import Breadcrumbs from '../components/core/Breadcrumbs.vue'
import SortBy from '../components/core/SortBy.vue'
import SortByMobile from '../components/core/SortByMobile.vue'
import { Logger } from '@vue-storefront/core/lib/logger'
import { getSearchOptionsFromRouteParams } from '@vue-storefront/core/modules/catalog-next/helpers/categoryHelpers'
import config from 'config'
import { mapGetters } from 'vuex'
import { catalogHooksExecutors } from '@vue-storefront/core/modules/catalog-next/hooks'
import { localizedRoute } from '@vue-storefront/core/lib/multistore'
import { htmlDecode } from '@vue-storefront/core/filters'
import {
  buildFilterProductsQuery,
  getThumbnailCategoryPath as _thumbnailHelper,
  isServer
} from '@vue-storefront/core/helpers'
import ActiveFilters from '../components/core/blocks/Category/ActiveFilters.vue'
import Marki from 'theme/components/core/blocks/Category/Marki.vue'
import SubscriptionPlans from 'theme/components/core/blocks/Category/SubscriptionPlans.vue'
import ListingPagination from 'theme/components/core/ListingPagination.vue'

const THEME_PAGE_SIZE = 20

const composeInitialPageState = async (store, route, forceLoad = false) => {
  try {
    const filters = getSearchOptionsFromRouteParams(route.params)
    const cachedCategory = store.getters['category-next/getCategoryFrom'](route.path)
    const currentCategory = cachedCategory && !forceLoad ? cachedCategory : await store.dispatch('category-next/loadCategory', { filters })
    const page = route.query && route.query.page && !isNaN(route.query.page) && route.query.page > 0 && route.query.page < 501
      ? route.query.page
      : 1 // elastic can return only 10000 hits, so 501 is the max page number
    const start = (page - 1) * THEME_PAGE_SIZE;
    await store.dispatch('category-next/loadCategoryProducts', { route, category: currentCategory, pageSize: THEME_PAGE_SIZE, loadFrom: start })
    const breadCrumbsLoader = store.dispatch('category-next/loadCategoryBreadcrumbs', { category: currentCategory, currentRouteName: currentCategory.name, omitCurrent: true })

    if (isServer) await breadCrumbsLoader
    catalogHooksExecutors.categoryPageVisited(currentCategory)
  } catch (e) {
    Logger.error('Problem with setting Category initial data!', 'category', e)()
  }
}

export default {
  components: {
    LazyHydrate,
    ProductListing,
    Breadcrumbs,
    Sidebar,
    SortBy,
    SortByMobile,
    ActiveFilters,
    SubscriptionPlans,
    Marki,
    ListingPagination
  },
  data () {
    return {
      getMoreCategoryProducts: [],
      currentPage: 1,
      isFiltersToogle: true,
      defaultColumn: 'on',
      loadingProducts: false,
      loading: true,
      expanded: true
    }
  },
  computed: {
    ...mapGetters({
      getCurrentSearchQuery: 'category-next/getCurrentSearchQuery',
      getCategoryProducts: 'category-next/getCategoryProducts',
      getCurrentCategory: 'category-next/getCurrentCategory',
      getCategoryProductsTotal: 'category-next/getCategoryProductsTotal',
      getAvailableFilters: 'category-next/getAvailableFilters',
      hasActiveFilters: 'category-next/hasActiveFilters',
      isMobileFitersOpen: 'ui/isMobileFitersOpen',
      getCurrentFilters: 'category-next/getCurrentFilters'
    }),
    showCategoryDescribe () {
      if (!this.$route.query['page']) {
        return true
      } else {
        return false
      }
    },
    isQueryFilterActive () {
      return this.$store.state.ui.isQueryFilterActive
    },
    designerCategoryId () {
      return config.server.categoryIdsMap.designerCategoryId
    },
    fashionSubscriptionCategoryId () {
      return config.server.categoryIdsMap.fashionSubscriptionCategoryId
    },
    totalPages () {
      return Math.ceil(this.getCategoryProductsTotal / THEME_PAGE_SIZE);
    },
    routerPage () {
      return this.$route.query['page']
    },
    isActiveFilters () {
      return Object.keys(this.getCurrentFilters).length ||
        this.isSaleFilterActive ||
        this.isNewFilterActive ||
        this.isBestselleryFilterActive ||
        this.isQueryFilterActive
    },
    isSaleFilterActive () {
      return this.$store.state.ui.isSaleFilterActive
    },
    isBestselleryFilterActive () {
      return this.$store.state.ui.isBestselleryFilterActive
    },
    isNewFilterActive () {
      return this.$store.state.ui.isNewFilterActive
    },
    products () {
      return this.getMoreCategoryProducts.length === 0
        ? this.getCategoryProducts
          .filter((product, i) => {
            return i < THEME_PAGE_SIZE;
          })
        : this.getMoreCategoryProducts
    },
    isQueryNotEmpty () {
      return this.$route.query
        ? this.$route.query.query || this.$route.query.subscription || this.$route.query.new
        : false
    },
    thumbnail () {
      return this.getThumbnail(this.getCurrentCategory.image, 450, 350, 'category')
    },
    thumbnail1 () {
      return this.getThumbnail(this.getCurrentCategory.thumbnail_image, 450, 350, 'category')
    },
    isLazyHydrateEnabled () {
      return config.ssr.lazyHydrateFor.includes('category-next.products')
    },
    isCategoryEmpty () {
      return this.getCategoryProductsTotal === 0
    }
  },
  mounted () {
    this.currentPage = this.$route.query['page'] && parseInt(this.$route.query['page'], 10) > 0
      ? Math.abs(parseInt(this.$route.query['page'], 10))
      : 1
    if (this.getMoreCategoryProducts.length === 0 && (isNaN(this.currentPage) || (this.currentPage > this.totalPages))) {
      this.changePage()
    }
    window.smoothscroll = () => {
      let toYcord = 130
      let currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > toYcord) {
        window.requestAnimationFrame(window.smoothscroll)
        window.scrollTo(0, Math.floor(currentScroll - (currentScroll / 5)))
      }
    }
  },
  watch: {
    // sortOrder () {
    //   if (this.currentPage > 1) {
    //     this.changePage();
    //   }
    // },
    $route: {
      // immediate: true,
      handler (to, from) {
        if (from && from.query && from.query.page && !to.query.page) {
          this.initPagination()
        }
        this.changePage(parseInt(to.query.page) || 1);
      }
    }
  },
  async asyncData ({ store, route, context }) { // this is for SSR purposes to prefetch data - and it's always executed before parent component methods
    if (context) context.output.cacheTags.add('category')
    await composeInitialPageState(store, route)
  },
  async beforeRouteEnter (to, from, next) {
    if (isServer) next() // SSR no need to invoke SW caching here
    else if (!from.name) { // SSR but client side invocation, we need to cache products and invoke requests from asyncData for offline support
      next(async vm => {
        vm.loading = true
        vm.$store.commit('ui/routeChanged', { to: to, from: from })
        await composeInitialPageState(vm.$store, to, true)
        await vm.$store.dispatch('category-next/cacheProducts', { route: to }) // await here is because we must wait for the hydration
        vm.loading = false
      })
    } else { // Pure CSR, with no initial category state
      next(async vm => {
        vm.loading = true
        vm.$store.commit('ui/routeChanged', { to: to, from: from })
        vm.$store.dispatch('category-next/cacheProducts', { route: to })
        vm.loading = false
      })
    }
  },
  methods: {
    getLocaleByStoreId (storeId) {
      for (let storeCode of config.storeViews.mapStoreUrlsFor) {
        if (!config.storeViews[storeCode]) continue
        if (config.storeViews[storeCode].storeId === Number(storeId)) {
          return [
            true,
            config.storeViews[storeCode].i18n.defaultLocale,
            config.storeViews[storeCode].url
          ]
        }
      }
      return [false, null, null]
    },
    start () {
      return (this.currentPage - 1) * THEME_PAGE_SIZE
    },
    end () {
      let end = (this.currentPage - 1) * THEME_PAGE_SIZE + THEME_PAGE_SIZE
      return this.getCategoryProductsTotal < end
        ? this.getCategoryProductsTotal
        : end
    },
    async changePage (page = this.currentPage) {
      if (page > this.totalPages) {
        let query = Object.assign({}, this.$route.query)
        query.page = 1
        this.$router.push({ query })
        return
      }
      const start = (page - 1) * THEME_PAGE_SIZE;
      if (
        start < 0 ||
        start >= this.getCategoryProductsTotal ||
        (this.getCategoryProductsTotal < THEME_PAGE_SIZE && page !== 1)
      ) {
        return;
      }
      const { includeFields, excludeFields } = config.entities.productList;
      const { filters } = this.getCurrentSearchQuery;
      const filterQr = buildFilterProductsQuery(
        this.getCurrentCategory,
        filters
      );
      // custom filters
      const rangeqr = {}
      rangeqr['gte'] = 'now/d'
      if (this.$store.state.ui.isNewFilterActive) filterQr.applyFilter({ key: 'news_to_date', value: rangeqr })
      if (this.$store.state.ui.isQueryFilterActive) filterQr.setSearchText(this.$route.query['query'])
      if (this.$store.state.ui.isSubscriptionFilterActive) filterQr.applyFilter({ key: 'subscription_points', value: { 'gt': 0 } })
      if (this.$store.state.ui.isShowroomFilterActive) filterQr.applyFilter({ key: 'stock.source_codes', value: { 'in': ['showroom'] } })
      if (this.$store.state.ui.isVideoFilterActive) filterQr.applyFilter({ key: 'vimeo_id', value: { 'gt': 0 } })
      // end custom filters
      const searchResult = await this.$store.dispatch('product/findProducts', {
        query: filterQr,
        start: start,
        sort: this.getCurrentSearchQuery.sort ? this.getCurrentSearchQuery.sort : `${config.products.defaultSortBy.attribute}:${config.products.defaultSortBy.order}`,
        includeFields: includeFields,
        excludeFields: excludeFields,
        size: THEME_PAGE_SIZE,
        options: {
          populateRequestCacheTags: true,
          prefetchGroupProducts: false,
          setProductErrors: false,
          fallbackToDefaultWhenNoAvailable: true,
          assignProductConfiguration: false,
          separateSelectedVariant: false
        }
      })
      this.getMoreCategoryProducts = searchResult.items
      // this.$store.commit('category-next/category/ADD_PRODUCTS', searchResult.items)
      this.currentPage = page;
      window.smoothscroll()
    },
    initPagination () {
      this.currentPage = 1;
    },
    expandDesc () {
      this.expanded = true
    },
    resetAllFilters () {
      this.$store.dispatch('category-next/resetSearchFilters')
    },
    toggleFilters () {
      // this.$store.commit('ui/setOverlay', true)
      this.$store.dispatch('ui/toogleMobileFilter', true)
      // let body = document.getElementsByTagName('body')[0]
      // body.classList.add('iphone-scroll')
    },
    onFiltersChange (isFiltersToogle) {
      this.isFiltersToogle = isFiltersToogle
    },
    async changeFilter (filterVariant) {
      this.$store.dispatch('category-next/switchSearchFilters', [filterVariant])
    }
  },
  metaInfo () {
    let link = []
    let alternates = {}
    if (this.getCurrentCategory.store_view_urls[`store_0`]) {
      for (let storecode of config.storeViews.mapStoreUrlsFor) {
        let storeCodeLocale = config.storeViews[storecode].i18n.defaultLocale
        let storeCodeUrl = config.storeViews[storecode].url
        let hreflang = storeCodeLocale === 'en-US' ? 'x-default' : storeCodeLocale
        if (storeCodeLocale !== config.storeViews[this.$store.state.storeView.storeCode].i18n.defaultLocale) {
          alternates[hreflang] = {
            rel: 'alternate',
            hreflang: hreflang,
            href: config.server.hostName + storeCodeUrl + '/' + this.getCurrentCategory.store_view_urls[`store_0`]
          }
        }
      }
    }
    for (let storecode of Object.keys(this.getCurrentCategory.store_view_urls)) {
      const storeId = storecode && storecode.split('_')[1]
      if (!storeId) continue
      let [ok, locale, url] = this.getLocaleByStoreId(storeId)
      if (!ok || locale === config.storeViews[this.$store.state.storeView.storeCode].i18n.defaultLocale) continue
      let hreflang = locale === 'en-US' ? 'x-default' : locale
      alternates[hreflang] = {
        rel: 'alternate',
        hreflang: hreflang,
        href: config.server.hostName + url + '/' + this.getCurrentCategory.store_view_urls[`store_${storeId}`]
      }
    }
    link = Object.values(alternates)
    link.push({
      rel: 'canonical',
      href: config.server.hostName + this.$route.path
    })
    if (this.$route.query.page) {
      let prevLink = {}
      let nextLink = {}
      if (this.currentPage > 1) {
        prevLink = {
          rel: 'prev',
          href: localizedRoute('/' + this.getCurrentCategory.url_path + '?page=' + (this.currentPage - 1))
        }
        link.push(prevLink)
      }
      if (this.totalPages > this.currentPage) {
        nextLink = {
          rel: 'next',
          href: localizedRoute('/' + this.getCurrentCategory.url_path + '?page=' + (this.currentPage + 1))
        }
        link.push(nextLink)
      }
    }
    return {
      htmlAttrs: { lang: config.storeViews[this.$store.state.storeView.storeCode].i18n.defaultLocale },
      titleTemplate: this.getCurrentCategory.meta_title ? '%s' : '%s - E-Garderobe',
      link,
      title: this.getCurrentCategory.meta_title ? htmlDecode(this.getCurrentCategory.meta_title) : this.getCurrentCategory.name,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.getCurrentCategory.meta_description ? htmlDecode(this.getCurrentCategory.meta_description) : htmlDecode(this.getCurrentCategory.description).replace(/<[^>]+>/g, ' ').replace(/\s{2,10}/g, ' ')
        },
        {
          vmid: 'og:locale',
          property: 'og:locale',
          content: this.$store.state.storeView.storeCode ? config.storeViews[this.$store.state.storeView.storeCode].i18n.defaultLocale : ''
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: this.getCurrentCategory.meta_title ? htmlDecode(this.getCurrentCategory.meta_title) : htmlDecode(this.getCurrentCategory.name)
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: this.getCurrentCategory.meta_description ? htmlDecode(this.getCurrentCategory.meta_description) : htmlDecode(this.getCurrentCategory.description).replace(/<[^>]+>/g, ' ').replace(/\s{2,10}/g, ' ')
        },
        {
          vmid: this.getCurrentCategory.url_path ? 'og:url' : '',
          property: this.getCurrentCategory.url_path ? 'og:url' : '',
          content: this.getCurrentCategory.url_path ? htmlDecode(config.server.hostName + '/' + this.getCurrentCategory.url_path) : ''
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
$color-main: color(main-gray);
$main: color(main);
$white: color(white);
  #category {
    @media (max-width: 991px) {
      padding-top: 0px;
      .breadcrumbs-row {
        padding-top: 0px;
      }
    }
  }
  .loader-text {
    font-size: 18px;
    @media (max-width: 767px) {
      font-size: 16px;
    }
  }
  .category-header {
    &.fixed {
      top: -34px;
    }
    .row {
      align-items: stretch;
    }
    transition: all 0.3s;
    top: 0px;
    left: 0;
    right: 0;
    z-index: 6;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .category-filters.active-filters {
    top: 0;
    transition: all 0.3s;
    .fixed-bar {
      //  @media (max-width: 991px) {
      //   display: none;
      // }
      &.full-width {
        left: 8px;
      }
      transition: all 0.3s;
      position: fixed;
      top: 100px;
      z-index: 2;
      padding-top: 5px;
      padding-left: 5px;
      padding-right: 5px;
      position: fixed;
      top: 70px;
      background-color: $color-main;
      z-index: 2;
      right: 8px;
      left: 21%;
    }
  }
  .offer {
    padding-top: calc(100% * 1/7);
    position: relative;
    .offer-image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  .btn {
    &__filter {
      min-width: 100px;
    }
  }
  .mobile-sorting {
    display: none;
  }
  .sorting {
    label {
      margin-right: 10px;
    }
  }
  .category-title {
    @media (max-width: 991px) {
      font-weight: 500;
      font-size: 26px;
      margin-top: 5px;
      margin-bottom: 5px;
    }
  }

  @media (max-width: 991px) {
    .products-list {
      width: 100%;
      max-width: none;
    }
    .sorting {
      display: none;
    }

    .mobile-sorting {
      display: block;
    }

    .category-filters {
      display: none;
    }
  }

  .close-container {
    left: 0;
  }

  .close {
    margin-left: auto;
  }
  .category-inner{
    max-height: 6.6em;
    overflow: hidden
  }
  .expanded{
    max-height: initial !important
  }
  span.show-more {
    text-transform: capitalize;
    font-weight: bold;
    cursor: pointer;
    display: inline-block;
    padding-right: 5px;
    padding-bottom: 5px;
    padding-top: 5px;
    margin-top: 15px;
  }
  .category-filters.active-filters {
    @media (max-width: 991px) {
      position: fixed;
      top: 0;
      left: 0;
      padding: 0;
      z-index: 11;
      right: 15%;
      display: block;
      bottom: 0;
      background-color: #fff;
      padding-top: 50px;
      padding-bottom: 70px;
      > div {
        &:last-child {
          overflow-y: scroll;
        }
        margin-left: 50px;
        margin-right: 50px;
        max-height: 100%;
      }
    }
  }
  .fs-basic {
    font-size: 0.8em;
  }
  .container-fluid {
    > .container {
      @media (max-width: 767px) {
        padding-top: 0;
        padding-bottom: 0;
      }
    }
    @media (max-width: 767px) {
      background-color: white;
    }
  }
  .brand-header {
    @media (max-width: 767px) {
      text-align: center;
    }
    h1 {
      @media (max-width: 991px) {
        font-size: 30px;
      }
      @media (max-width: 767px) {
        font-size: 25px;
      }
    }
    span {
      @media (max-width: 991px) {
        line-height: 1.8em;
        max-height: 90px;
        overflow: hidden;
        display: block;
      }
    }
  }
  .brand-image {
    @media (max-width: 767px) {
      max-height: 150px;
    }
    object-fit: cover;
    max-height: 350px;
    padding-left: 5px;
    padding-right: 5px;
  }

.product-list__pagination {
  display: flex;
  justify-content: center;
  align-items: center;
}
.productTotal-text {
  font-size: 0.9em;
}
</style>
